'use strict';
export var tokenKey: string = 'Not-Set';

export var authUser = {
    isLoggedIn: false,
    userName: ''
};

export function setTokenKey(value: string) {
    tokenKey = value;
}

export class UserRoles {
    public static All: string = 'All';
    public static IS: string = '39D7075B-70D6-E611-9F36-005056B00B08';
    public static AT: string = '4A2A10A2-7CD3-E611-9F36-005056B00B08';
    public static SC: string = '65C5D5FA-58E9-EB11-A2F3-005056822A85';
    public static CCRO: string = '7272DF72-59E9-EB11-A2F3-005056822A85';
    public static PI: string = '12BA90EF-E3EA-EB11-A2F3-005056822A85';
    public static COI: string = '13BA90EF-E3EA-EB11-A2F3-005056822A85';
    public static SN: string = '14BA90EF-E3EA-EB11-A2F3-005056822A85';
    public static MB: string = '15BA90EF-E3EA-EB11-A2F3-005056822A85';
    public static MM: string = '16BA90EF-E3EA-EB11-A2F3-005056822A85';
    public static CLS: string = 'F9105ED5-1DDF-EB11-A2F8-005056827D1F';
    public static PM: string = '53B5AEFE-3FE8-E611-9F36-005056B00B08';
    public static PDC: string = '409C1D14-4801-EA11-A1A7-005056B00B08';
    public static LA: string = '4770E71C-4801-EA11-A1A7-005056B00B08';
    public static MG: string = '3611E136-CC20-EA11-B484-005056B00B08';
    public static IT: string = '3711E136-CC20-EA11-B484-005056B00B08';
    public static RAQA: string = '3811E136-CC20-EA11-B484-005056B00B08';
    public static ET: string = '3511E136-CC20-EA11-B484-005056B00B08';
    public static AM: string = '732F991E-AFF6-EC11-A322-005056827D1F';
    public static MT: string = '3CD7075B-70D6-E611-9F36-005056B00B08';
    public static RO: string = '40D7075B-70D6-E611-9F36-005056B00B08';
    public static IRO: string = '94B4BBDF-3FE8-E611-9F36-005056B00B08';
    public static OT: string = 'F7F0C30E-40E8-E611-9F36-005056B00B08';
    public static PSM: string = '43D34922-252F-E711-B57D-005056B00B08';
    public static GLS: string = 'E4A0EC25-C1AC-E711-A836-005056B00B08';
    public static RW: string = '4DDB3199-6948-E811-8126-005056B00B08';
    public static BD: string = '4EDB3199-6948-E811-8126-005056B00B08';
    public static DM: string = '4FDB3199-6948-E811-8126-005056B00B08';
    public static CRO: string = 'EBB24318-8748-E811-8126-005056B00B08';
    public static SM: string = 'EF8A7E11-8E60-E711-AB5D-005056B00B08';
}

export class IMSModules {
    public static Home: string = '645E26CB-75D6-E611-9F36-005056B00B08';
    public static Admin: string = '655E26CB-75D6-E611-9F36-005056B00B08';
    public static InternalUsers: string = '665E26CB-75D6-E611-9F36-005056B00B08';
    public static ExternalUsers: string = '675E26CB-75D6-E611-9F36-005056B00B08';
    public static MyContacts: string = '685E26CB-75D6-E611-9F36-005056B00B08';
    public static SponsorContact: string = '695E26CB-75D6-E611-9F36-005056B00B08';
    public static InvestigatorSite: string = '6A5E26CB-75D6-E611-9F36-005056B00B08';
    public static ClinicalTeam: string = '6B5E26CB-75D6-E611-9F36-005056B00B08';
    public static Study: string = '6C5E26CB-75D6-E611-9F36-005056B00B08';
    public static MyStudies: string = '6D5E26CB-75D6-E611-9F36-005056B00B08';
    public static StudyFiles: string = '6E5E26CB-75D6-E611-9F36-005056B00B08';
    public static AuditReport: string = '6F5E26CB-75D6-E611-9F36-005056B00B08';
    public static ManageLinkedSites: string = '8E419AB8-FA8B-E711-BD2E-005056B00B08';
    public static ManageStabilityWorkFile: string = '7545AB12-F791-E711-9287-005056B00B08';
}

export class EzMoneyModules {
    public static Specimen: string = 'E8D5B88A-D243-E811-8126-005056B00B08';
    public static Cover: string = 'B03B4853-AF43-E811-9B2B-005056B02CB4';
    public static Timeline: string = 'B13B4853-AF43-E811-9B2B-005056B02CB4';
    public static AssessmentSchedule: string = 'B23B4853-AF43-E811-9B2B-005056B02CB4';
    public static StartUp: string = 'B33B4853-AF43-E811-9B2B-005056B02CB4';
    public static Speciality: string = 'B43B4853-AF43-E811-9B2B-005056B02CB4';
    public static PMDM: string = 'B53B4853-AF43-E811-9B2B-005056B02CB4';
    public static Analysis: string = 'B63B4853-AF43-E811-9B2B-005056B02CB4';
    public static Kits: string = 'B73B4853-AF43-E811-9B2B-005056B02CB4';
    public static Outbound: string = 'B83B4853-AF43-E811-9B2B-005056B02CB4';
    public static Inbound: string = 'B93B4853-AF43-E811-9B2B-005056B02CB4';
    public static CentralLab: string = 'BA3B4853-AF43-E811-9B2B-005056B02CB4';
    public static RentalFees: string = 'BB3B4853-AF43-E811-9B2B-005056B02CB4';
    public static Assumption: string = 'BC3B4853-AF43-E811-9B2B-005056B02CB4';
    public static BudgetSummary: string = 'BD3B4853-AF43-E811-9B2B-005056B02CB4';
    public static Variance: string = 'BE3B4853-AF43-E811-9B2B-005056B02CB4';
    public static Parameters: string = 'BF3B4853-AF43-E811-9B2B-005056B02CB4';
    public static QuotationStatus: string = 'E9D5B88A-D243-E811-8126-005056B00B08';
    public static Transportaion: string = '5BF8C2EE-5ACD-E811-B828-005056B00B08';
}

export class EzoneyCurrency {
    public static China: string = '909BDB6B-1B22-E811-88E9-005056B00B08';
    public static Singapore: string = '919BDB6B-1B22-E811-88E9-005056B00B08';
    public static USDollar: string = '929BDB6B-1B22-E811-88E9-005056B00B08';
    public static Euro: string = '939BDB6B-1B22-E811-88E9-005056B00B08';
}

export class EzoneyCountry {
    public static Americas: string = '46D7D5D5-942E-E811-88E9-005056B00B08';
    public static Europe: string = '47D7D5D5-942E-E811-88E9-005056B00B08';
    public static Singapore: string = '48D7D5D5-942E-E811-88E9-005056B00B08';
    public static China: string = '49D7D5D5-942E-E811-88E9-005056B00B08';
}

export class Feature {
    public static Dashboard: string = 'F05D4450-3CE8-E611-9F36-005056B00B08';
    public static ManageInternalUsers: string = '409D7D5F-3CE8-E611-9F36-005056B00B08';
    public static ManageExternalUsers: string = '90545067-3CE8-E611-9F36-005056B00B08';
    public static ManageUserManuals: string = 'D1D77D21-9FE8-E811-9C1A-005056B00B08';
    public static StudyOverview: string = '80913370-3CE8-E611-9F36-005056B00B08';
    public static ManageInvestigatorSites: string = 'D046067F-3CE8-E611-9F36-005056B00B08';
    public static ManageContacts: string = 'C0331F9D-3CE8-E611-9F36-005056B00B08';
    public static MyStudyOverview: string = '006F08A7-3CE8-E611-9F36-005056B00B08';
    public static StudyDetails: string = '44C17AB0-3CE8-E611-9F36-005056B00B08';
    public static StudyContactsOverview: string = '9B08A9C7-3CE8-E611-9F36-005056B00B08';
    public static StudyFiles: string = '44A315CE-3CE8-E611-9F36-005056B00B08';
    public static ManageStudyFiles: string = '7CA3A594-C2EA-E611-9F36-005056B00B08';
    public static MyCommunicationPref: string = 'DD071DCD-C8F4-E611-8DB3-005056B00B08';
    public static StudySetup: string = '9197F272-242F-E711-B57D-005056B00B08';
    public static ManageRequisitions: string = '490A2976-9860-E711-AB5D-005056B00B08';
    public static ManageSpecimens: string = '4C3B32F3-B471-E711-BD2E-005056B00B08';
    public static ManageLinkedSites: string = '0A2F8AD2-FF8B-E711-BD2E-005056B00B08';
    public static Files: string = '39546551-64AE-E711-A836-005056B00B08';
    public static ManageStabilityWorkFiles: string = '75C70912-C2AC-E711-A836-005056B00B08';
    public static AlertReportMailSubjectConfig: string = '62DBC41D-D4CD-E711-B785-005056B00B08';
    public static ManageOrders: string = 'E0826493-275B-E711-AB5D-005056B00B08';
    public static StudyContactDataAccess: string = '63DBC41D-D4CD-E711-B785-005056B00B08';
    public static ContactReportRoutingPrefOverview: string = '705E929E-8915-E811-83A5-005056B00B08';
    public static HideUndoHideReportFeature: string = 'E37F098F-6C32-E811-88E9-005056B00B08';
    public static HideUndoHideResultFeature: string = '35D34411-2A3E-E811-8126-005056B00B08';
    public static SpecimenDescriptionsFeature: string = '1774B609-725F-E811-B810-005056B00B08';
    public static OptionalTestsFeature: string = '1874B609-725F-E811-B810-005056B00B08';
    public static VersionQuotation: string = 'D9A7486D-F24D-E811-9251-005056B00B08';
    public static AmendQuotation: string = 'DAA7486D-F24D-E811-9251-005056B00B08';
    public static CloneQuotation: string = 'DBA7486D-F24D-E811-9251-005056B00B08';
    public static GenerateDraftQuotation: string = 'DCA7486D-F24D-E811-9251-005056B00B08';
    public static ShowPortalAccess: string = '5AC555EA-6DB6-E811-B828-005056B00B08';
    public static ManageIsolateRequisitions: string = '2737D5AA-213B-E911-B956-005056B00B08';
    public static ViewUnBlindedDataFlag: string = '37B51DFA-7F45-E911-B956-005056B00B08';
    public static CommunicationPreferenceDetails: string = '8113A53D-E04B-E911-B956-005056B00B08';
    public static SponsorContactEcomAccess: string = '10DE00A6-26D9-E911-8952-005056B02CB4';
}

export class StudyStatus {
    public static Active: string = '642a10a2-7cd3-e611-9f36-005056b00b08';
    public static Closed: string = '652a10a2-7cd3-e611-9f36-005056b00b08';
    public static Draft: string = '662a10a2-7cd3-e611-9f36-005056b00b08';
    public static Cancelled: string = '852a10a2-7cd3-e611-9f36-005056b00b08';
    public static Completed: string = '862a10a2-7cd3-e611-9f36-005056b00b08';
    public static OnHold: string = '872a10a2-7cd3-e611-9f36-005056b00b08';
    public static Obsolete: string = '42df097b-0d40-ee11-a34a-005056822a85';
}

export class StudySetupVersionStatus {
    public static Draft: string = '7EDB66F3-BE24-E711-B57D-005056B00B08';
    public static Active: string = '7FDB66F3-BE24-E711-B57D-005056B00B08';
    public static Completed: string = '80DB66F3-BE24-E711-B57D-005056B00B08';
    public static Cancelled: string = '81DB66F3-BE24-E711-B57D-005056B00B08';
    public static ReadyForQC: string = '7ECC1D48-D92E-E911-B956-005056B00B08';
}

export class StudySetupStatus {
    public static Draft: string = '7EDB66F3-BE24-E711-B57D-005056B00B08';
    public static draft: string = '7edb66f3-be24-e711-b57d-005056b00b08';
    public static Active: string = '7FDB66F3-BE24-E711-B57D-005056B00B08';
    public static Completed: string = '80DB66F3-BE24-E711-B57D-005056B00B08';
    public static Cancelled: string = '81DB66F3-BE24-E711-B57D-005056B00B08';
    public static ReadyForQC: string = '7ECC1D48-D92E-E911-B956-005056B00B08';
}

export class QuotationStatus {
    public static Draft: string = '44524269-9d39-e811-8126-005056b00b08';
    public static InReview: string = '45524269-9d39-e811-8126-005056b00b08';
    public static Approved: string = '46524269-9d39-e811-8126-005056b00b08';
    public static Awarded: string = '47524269-9d39-e811-8126-005056b00b08';
}

export class InvoiceStatus {
    public static InProgress: string = '56F8C2EE-5ACD-E811-B828-005056B00B08';
    public static Draft: string = '57F8C2EE-5ACD-E811-B828-005056B00B08';
    public static InReview: string = '58F8C2EE-5ACD-E811-B828-005056B00B08';
    public static Approved: string = '59F8C2EE-5ACD-E811-B828-005056B00B08';
    public static SentToSponsor: string = '5AF8C2EE-5ACD-E811-B828-005056B00B08';
}

export class AccountReceivableTypeList {
    public static Complete: string = '858007D1-71ED-E811-9C1A-005056B00B08';
    public static Partial: string = '868007D1-71ED-E811-9C1A-005056B00B08';
}

export class RoleList {
    public static ProposalDevelopment: string = '8ec067b9-9c1b-e811-83a5-005056b00b08';
    public static InternalReviewer: string = '4ddb3199-6948-e811-8126-005056b00b08';
    public static BusinessDevelopment: string = '4edb3199-6948-e811-8126-005056b00b08';
    public static ProjectManager: string = '53b5aefe-3fe8-e611-9f36-005056b00b08';
    public static InovicingSpecialist: string = '5022d65b-80ee-e811-9c1a-005056b00b08';
    public static IncvoiceSpecialist: string = '5022d65b-80ee-e811-9c1a-005056b00b08';
    public static DatatEntry: string = '4fdb3199-6948-e811-8126-005056b00b08';
    public static DataAnalyst: string = 'e4309e3c-80ee-e811-9c1a-005056b00b08';
    public static PDC: string = '409C1D14-4801-EA11-A1A7-005056B00B08';
    public static LA: string = '4770E71C-4801-EA11-A1A7-005056B00B08';
    public static Administrator: string = '4A2A10A2-7CD3-E611-9F36-005056B00B08';
    public static Management: string = '3611E136-CC20-EA11-B484-005056B00B08';
    public static IT: string = '3711E136-CC20-EA11-B484-005056B00B08';
    public static RAQA: string = '3811E136-CC20-EA11-B484-005056B00B08';
    public static CLS: string = 'F9105ED5-1DDF-EB11-A2F8-005056827D1F';
    public static SC: string = '65C5D5FA-58E9-EB11-A2F3-005056822A85';
    public static CRO: string = '7272DF72-59E9-EB11-A2F3-005056822A85';
    public static PI: string = '12BA90EF-E3EA-EB11-A2F3-005056822A85';
    public static CI: string = '13BA90EF-E3EA-EB11-A2F3-005056822A85';
    public static SN: string = '14BA90EF-E3EA-EB11-A2F3-005056822A85';
    public static MB: string = '15BA90EF-E3EA-EB11-A2F3-005056822A85';
    public static MM: string = '16BA90EF-E3EA-EB11-A2F3-005056822A85';
}

export class DataCaptureFieldId {
    public static SubjectId: string = '6C9B7C92-3128-E811-88E9-005056B00B08';
    public static SubjectInitials: string = '6D9B7C92-3128-E811-88E9-005056B00B08';
    public static SubjectMisc1: string = '6E9B7C92-3128-E811-88E9-005056B00B08';
    public static SubjectMisc2: string = '6F9B7C92-3128-E811-88E9-005056B00B08';
    public static Sex: string = '7A9B7C92-3128-E811-88E9-005056B00B08';
    public static Birthdate: string = '7B9B7C92-3128-E811-88E9-005056B00B08';
    public static CollectionDate: string = '7C9B7C92-3128-E811-88E9-005056B00B08';
    public static CollectionTime: string = '7D9B7C92-3128-E811-88E9-005056B00B08';
    public static OrderingPhysician: string = '7E9B7C92-3128-E811-88E9-005056B00B08';
    public static Comments: string = '8A9B7C92-3128-E811-88E9-005056B00B08';
    public static CustomField1: string = '8B9B7C92-3128-E811-88E9-005056B00B08';
    public static CustomField2: string = '8C9B7C92-3128-E811-88E9-005056B00B08';
    public static CustomField3: string = '8D9B7C92-3128-E811-88E9-005056B00B08';
    public static DiseaseType: string = '8E9B7C92-3128-E811-88E9-005056B00B08';
    public static TumorCellularity: string = '8F9B7C92-3128-E811-88E9-005056B00B08';
    public static Cuid: string = '909B7C92-3128-E811-88E9-005056B00B08';
}

export class StudyReportType {
    public static ClinicalReport: string = '582A10A2-7CD3-E611-9F36-005056B00B08';
    public static AlertReport: string = '572A10A2-7CD3-E611-9F36-005056B00B08';
}

export class Defaults {
    public static EmptyGuid: string = '00000000-0000-0000-0000-000000000000';
}

export class Constants {
    static readonly SHORT_DATE_FMT = 'dd-MMM-yyyy';
    static readonly DATE_TIME_FMT = `${Constants.SHORT_DATE_FMT} hh:mm:ss`;
}

export class SpecimenLevel {
    public static SpecimenLevelVisit: string = 'FEBF48A1-13FC-4EE2-935B-EF215CEEF852';
    public static SpecimenLevelShipment: string = 'AF8433A8-ED57-47AF-8D55-6AE5AB8CDB3B';
}

export class StudyReportStatus {
    public static Pending: string = '53178277-a431-e811-88e9-005056b00b08';
    public static Exported: string = '54178277-a431-e811-88e9-005056b00b08';
    public static Completed: string = '55178277-a431-e811-88e9-005056b00b08';
    public static Failed: string = '56178277-a431-e811-88e9-005056b00b08';
    public static OnHold: string = '177a2c02-a0e1-e811-9c1a-005056b00b08';
    public static Deferred: string = '2d1f8a75-3cfd-e811-bff3-005056b00b08';
}

export class SpecimenType {
    public static Standard: string = '778A317D-AA33-E711-B57D-005056B00B08';
    public static Backup: string = '788A317D-AA33-E711-B57D-005056B00B08';
    public static NoHandling: string = '798A317D-AA33-E711-B57D-005056B00B08';
}

export var templateVersion = "?v=" + Date.now();
export var generalLabs = ["BREDA", "SINGAPORE", "SHANGHAI"];

export class ParcelStatusId {
    public static DiscrepantId: string = "5b271db5-4c5c-e911-bb4a-005056b00b08";
    public static RegisteredId: string = "8fd5a373-4c5c-e911-bb4a-005056b00b08";
}

export class SampleRegistrationStatus {
    public static InitiateSecondEntry: string = "E31B1EA2-596D-E911-93F8-005056B00B08";
    public static RegistrationCompleted: string = "e31b2ea2-596d-e911-93f8-005056b00b08";
    public static InProgress: string = "E51B1EA2-596D-E911-93F8-005056B00B08";
    public static PartiallyCompleted: string = "E62B2EA2-596D-E911-93F8-005056B00B08";
    public static Cancelled: string = "ED43D91E-6EF2-EA11-A2D1-005056827D1F";
    public static Discrepant: string = "ED43D91E-6EF2-EA11-A2D1-004897827D1F";
    public static PartiallyDiscrepant: string = "ED43D91E-6EF2-EA11-A2D1-004987827D1F";
    public static PartiallyCancelled: string = "0c6cb438-9836-ee11-a34a-005056822a85";
}

export class LabelLayout {
    public static TubeLabel: string = "7b6cfb72-ba82-e911-a19c-005056b00b08";
}

export class Courier {
    public static TNT: string = "7A2CBC14-9066-E911-AC44-005056B02CB4";
    public static TNTawbLength: number = 28;
    public static UPS: string = "8A2CBC14-9066-E911-AC44-005056B02CB4";
    public static UPSawbLength: number = 18;
}

export class StudyType {
    public static InvoiceOnly: string = 'b61aa9c5-48a2-46a6-a424-c613089de5cb'
    public static LogisticsOnly: string = 'CB6204DB-ED10-43CD-867A-2028973E4C48'
    public static LoMaS: string = '842A10A2-7CD3-E611-9F36-005056B00B08'
    public static KitOnly: string = '562A10A2-7CD3-E611-9F36-005056B00B08'
    public static FullService = '552A10A2-7CD3-E611-9F36-005056B00B08'
    public static NA = '76574874-15F7-E911-A1A7-005056B00B08'
}

export class TableType {
    public static RequisitionSplits: string = '5B625AA3-A3A2-E711-99EC-005056B00B08';
    public static Studies: string = '210D5360-ACEE-E611-9F36-005056B00B08';
    public static StudyAdditionalFields: string = '38B04EED-B593-E711-9B62-005056B02CB4';
    public static SiteContacts: string = '220D5360-ACEE-E611-9F36-005056B00B08';
    public static StudyRegistries: string = '230D5360-ACEE-E611-9F36-005056B00B08';
    public static StudySites: string = '240D5360-ACEE-E611-9F36-005056B00B08';
    public static StudySiteContacts: string = '260D5360-ACEE-E611-9F36-005056B00B08';
    public static StudySiteReportRecipients: string = '270D5360-ACEE-E611-9F36-005056B00B08';
    public static StudySiteContactAddresses: string = '280D5360-ACEE-E611-9F36-005056B00B08';
    public static Addresses: string = '2E0D5360-ACEE-E611-9F36-005056B00B08';
    public static Contacts: string = '2F0D5360-ACEE-E611-9F36-005056B00B08';
    public static EmailAddresses: string = '300D5360-ACEE-E611-9F36-005056B00B08';
    public static PhoneNumbers: string = '4FCF6578-ADEE-E611-9F36-005056B00B08';
    public static Users: string = '50CF6578-ADEE-E611-9F36-005056B00B08';
    public static InvestigatorSites: string = '51CF6578-ADEE-E611-9F36-005056B00B08';
    public static Sponsors: string = '13B04EED-B593-E711-9B62-005056B02CB4';
    public static StudySetups: string = '14B04EED-B593-E711-9B62-005056B02CB4';
    public static StudySetupVersions: string = '15B04EED-B593-E711-9B62-005056B02CB4';
    public static StudyAgeRanges: string = '16B04EED-B593-E711-9B62-005056B02CB4';
    public static StudyDataCaptureFields: string = '17B04EED-B593-E711-9B62-005056B02CB4';
    public static studyDemographicGroups: string = '18B04EED-B593-E711-9B62-005056B02CB4';
    public static studySpecimens: string = '19B04EED-B593-E711-9B62-005056B02CB4';
    public static studySpecimenLabs: string = '1AB04EED-B593-E711-9B62-005056B02CB4';
    public static VisitRequisitionFields: string = '1BB04EED-B593-E711-9B62-005056B02CB4';
    public static visitSpecimens: string = '1C04EED-B593-E711-9B62-005056B02CB4';
    public static visitOptionalTests: string = '1DB04EED-B593-E711-9B62-005056B02CB4';
    public static studyHybridMappingDetails: string = '1EB04EED-B593-E711-9B62-005056B02CB4';
    public static studyHybridMappingDetailsExtension: string = '1FB04EED-B593-E711-9B62-005056B02CB4';
    public static studyOptionalTests: string = '20B04EED-B593-E711-9B62-005056B02CB4';
    public static studyOptionalTestLabs: string = '21B04EED-B593-E711-9B62-005056B02CB4';
    public static studyParticipantLabs: string = '22B04EED-B593-E711-9B62-005056B02CB4';
    public static StudyFileUploads: string = '23B04EED-B593-E711-9B62-005056B02CB4';
    public static StudyFiles: string = '24B04EED-B593-E711-9B62-005056B02CB4';
    public static StudyFileShares: string = '25B04EED-B593-E711-9B62-005056B02CB4';
    public static Subjects: string = '26B04EED-B593-E711-9B62-005056B02CB4';
    public static requisitions: string = '27B04EED-B593-E711-9B62-005056B02CB4';
    public static requisitionComments: string = '28B04EED-B593-E711-9B62-005056B02CB4';
    public static requisitionDataCaptureFields: string = '29B04EED-B593-E711-9B62-005056B02CB4';
    public static requisitionDiscrepancies: string = '2AB04EED-B593-E711-9B62-005056B02CB4';
    public static requisitionOptionalTests: string = '2BB04EED-B593-E711-9B62-005056B02CB4';
    public static specimens: string = '2CB04EED-B593-E711-9B62-005056B02CB4';
    public static shipmentManifests: string = '2DB04EED-B593-E711-9B62-005056B02CB4';
    public static shipmentManifestSpecimens: string = '2EB04EED-B593-E711-9B62-005056B02CB4';
    public static orders: string = '2FB04EED-B593-E711-9B62-005056B02CB4';
    public static orderDetails: string = '39B04EED-B593-E711-9B62-005056B02CB4';
    public static orderTests: string = '3AB04EED-B593-E711-9B62-005056B02CB4';
    public static sampleVisitDataCaptureFields: string = '3BB04EED-B593-E711-9B62-005056B02CB4';
    public static orderRequisitions: string = '30B04EED-B593-E711-9B62-005056B02CB4';
    public static StudyLaboratories: string = '31B04EED-B593-E711-9B62-005056B02CB4';
    public static UserRoles: string = '32B04EED-B593-E711-9B62-005056B02CB4';
    public static PrinterConfiguration: string = '34B04EED-B593-E711-9B62-005056B02CB4';
    public static PrinterLock: string = '35B04EED-B593-E711-9B62-005056B02CB4';
    public static Departments: string = '36B04EED-B593-E711-9B62-005056B02CB4';
    public static LinkedCompanies: string = '37B04EED-B593-E711-9B62-005056B02CB4';
    public static Visits: string = '3CB04EED-B593-E711-9B62-005056B02CB4';
    public static WorkFiles: string = '82A667CD-E293-E711-9B62-005056B02CB4';
    public static WorkFilesConditions: string = '83A667CD-E293-E711-9B62-005056B02CB4';
    public static WorkFileLinks: string = '84A667CD-E293-E711-9B62-005056B02CB4';
    public static NonVisitSpecificKitVisits: string = '1183F5BD-B153-47AE-B4C6-0EE237043CC8';
    public static NonVisitSpecificKits: string = 'A6FB110F-24E3-4C87-9686-8E51B92A19BF';
    public static BulkDownloadFiles: string = '0F0537EB-058E-4D9A-B947-97098A0FAEBF';
    public static AlertReportMailSubjectConfiguration: string = '9C205F18-57F4-4083-BAE3-9C4E76B4F7F4';
    public static BulkDownload: string = '00EC63AF-4386-431F-8DBF-A5C833A23F1D';
    public static StorageLocation: string = '01EC63AF-4386-431F-8DBF-A5C833A23F1D';
    public static Boxes: string = '02EC63AF-4386-431F-8DBF-A5C833A23F1D';
    public static Freezers: string = '03EC63AF-4386-431F-8DBF-A5C833A23F1D';
    public static LocationType: string = '04EC63AF-4386-431F-8DBF-A5C833A23F1DD';
    public static Others: string = '05EC63AF-4386-431F-8DBF-A5C833A23F1D';
    public static Shelves: string = '06EC63AF-4386-431F-8DBF-A5C833A23F1D';
    public static Towers: string = '07EC63AF-4386-431F-8DBF-A5C833A23F1D';
    public static ShipmentManifest: string = '933A81D2-EBAB-EA11-A2C8-005056822A85';
    public static DestructionManifest: string = 'E64D52F4-F561-EB11-A2EB-005056827D1F';
}

/*Study Phase Lookup*/
export class StudyPhaseLookup {
    StudyPhaseId: string
    StudyPhase: string
    Phase: string
    Description: string
}

export var studyPhaseLookup: StudyPhaseLookup[] = [
    { StudyPhaseId: "78574874-15F7-E911-A1A7-005056B00B08", StudyPhase: "N/A", Phase: "N/A", Description: "N/A" },
    { StudyPhaseId: "033FB7A9-2A31-427A-8744-70091894C24F", StudyPhase: "1", Phase: "Phase 1", Description: "Phase 1 : Dosing Safety" },
    { StudyPhaseId: "295ED0AC-1140-4A49-BF0E-F697217582BF", StudyPhase: "1.1", Phase: "Phase 1", Description: "Phase 1 : Dosing Safety" },
    { StudyPhaseId: "B692BC29-3F7A-4549-A6A7-C63F52403C93", StudyPhase: "1/2", Phase: "Phase 1", Description: "Phase 1 : Dosing Safety" },
    { StudyPhaseId: "B892C08C-D7AD-4A90-84E1-653697D77E3B", StudyPhase: "1b", Phase: "Phase 1", Description: "Phase 1b : Multiple Asscending Dose" },
    { StudyPhaseId: "55D0BAB8-3D8E-453D-B0A2-E8616A457171", StudyPhase: "2", Phase: "Phase 2", Description: "Phase 2: Safety" },
    { StudyPhaseId: "42C44347-09A6-4B27-83CF-94A588E3794A", StudyPhase: "2a", Phase: "Phase 2", Description: "Phase 2a : Dosing Determination" },
    { StudyPhaseId: "8E16E3E3-7134-4A07-9E99-579CCB05F1BC", StudyPhase: "2b", Phase: "Phase 2", Description: "Phase 2b : Drug Efficacy" },
    { StudyPhaseId: "A6C948D0-02FE-4FD2-A79E-7539985AF44A", StudyPhase: "2.1b", Phase: "Phase 2", Description: "" },
    { StudyPhaseId: "9753F08C-F18D-47CF-9F79-BDA10AA45EA0", StudyPhase: "2.2a", Phase: "Phase 2", Description: "" },
    { StudyPhaseId: "DCCC36B6-72EC-4DBB-A44A-58B779459E28", StudyPhase: "3", Phase: "Phase 3", Description: "Phase 3 : Safety and Efficacy" },
    { StudyPhaseId: "D3A838C6-CED3-4CB2-AAE8-683D0CAA78A1", StudyPhase: "3.3a", Phase: "Phase 3", Description: "Phase 3 : Safety and Efficacy" },
    { StudyPhaseId: "7E322944-5EBC-43E1-8D02-AE3C872350BC", StudyPhase: "3a", Phase: "Phase 3", Description: "Phase 3 : Safety and Efficacy" },
    { StudyPhaseId: "1791EB23-9E33-4D7D-94A1-C324BCB35A47", StudyPhase: "3b", Phase: "Phase 3", Description: "Phase 3 : Safety and Efficacy" },
    { StudyPhaseId: "F7204ACE-6EB7-4736-B289-A2DA5C74C91C", StudyPhase: "4", Phase: "Phase 4", Description: "Phase 4 : Safety, Post Marketing" },
    { StudyPhaseId: "DE99A450-3B97-4C9F-A6E0-B8050CDA878D", StudyPhase: "POC", Phase: "Proof of Concept", Description: "Proof of Concept" }
]

export class SampleOrderStatus {
    public static Failed: string = 'E01B1EA2-596D-E911-93F8-005056B00B08';
    public static Created: string = 'E61B1EA2-596D-E911-93F8-005056B00B08';
    public static InProgress: string = 'E71B1EA2-596D-E911-93F8-005056B00B08';
    public static InCopia: string = 'E81B1EA2-596D-E911-93F8-005056B00B08';
    public static Completed: string = 'E91B1EA2-596D-E911-93F8-005056B00B08';
}

export class LocationType {
    public static Freezer: string = '3F89BAC5-F485-EA11-A2C2-005056822A85';
    public static Shelf: string = '580D5B22-F585-EA11-A2C2-005056822A85';
    public static Tower: string = '5D25D44E-F585-EA11-A2C2-005056822A85';
    public static Box: string = '0AEB1376-F585-EA11-A2C2-005056822A85';
    public static Other: string = '703D84A3-F585-EA11-A2C2-005056822A85';
    public static Lab: string = '423B66E0-52B7-4871-A0CC-4E071F145AD6';
    public static Bench: string = '308CC483-3F71-49FD-B3E8-47E846F81C97';
    public static LN: string = '453B66E0-52B7-4871-A0CC-4E071F145AD6';
    public static WalkInFridge: string = '463B66E0-52B7-4871-A0CC-4E071F145AD6';
    public static Rack: string = '473B66E0-52B7-4871-A0CC-4E071F145AD6';
    public static PlateBox: string = '12F3DA94-CB03-F011-A2DB-84A938747F61'
}

export class StorageLocationStatus {
    public static Active: string = 'AED427BD-F685-EA11-A2C2-005056822A85';
    public static InActive: string = '7F3CC50A-F785-EA11-A2C2-005056822A85';
}

export class ActionType {
    public static Lab: string = '57DC7B88-5DBF-4698-AD02-FEF2C56C84BC';
    public static Store: string = '56DC7B88-5DBF-4698-AD02-FEF2C56C84BC';
    public static Other: string = '5890B864-6298-EA11-A2C2-005056822A85';
    public static Temporary: string = '07618B5F-F7C9-EA11-A2CD-005056822A85';
    public static ShipBox: string = '8810D6FD-7508-EB11-A2D8-005056822A85';
}

export class BoxCapacityType {
    public static TenTen: string = 'B3E85BEE-9EF1-400B-92B1-37EB1ED98230';
    public static NineNine: string = '4A41239D-B41A-4E2D-96A6-65076770169D';
    public static FourteenSeven: string = 'C1F4310C-97F9-EA11-A2D2-005056822A85';
    public static SevenSeven: string = '16C146A8-96F9-EA11-A2D2-005056822A85';
    public static TwoFifty: string = '4B41239D-B41A-4E2D-96A6-65076770169D';
    public static EightTwelve: string = '32163926-3599-EC11-A30D-005056827D1F';
    public static EightSix: string = '20EF96C8-DB38-ED11-A333-005056827D1F';
    public static ThreeThree: string = '9FF9BD0C-323E-ED11-A336-005056822A85';
    public static ElevenThirteen: string = 'B3E85BEE-9EF1-400B-92B1-37EB1ED98780';
    public static TwoNine: string = 'B3E85BEE-9EF1-401B-92B1-37EB1ED98783';
}

export class PlateBoxCapacityType {
    public static OneOne: string = 'F9BAD831-CD64-4359-9092-77DF0499D128';
    public static TwoOne: string = 'F60FCCB6-0374-4234-BAF9-5B3108751431';
    public static ThreeOne: string = '98E3E9F0-BBC6-4B1E-8723-210AB81A45E9';
    public static FourOne: string = 'F1504399-5157-428F-A8B5-29A5394912B6';
    public static FiveOne: string = 'B97716CA-8A48-46E5-ABF8-27FE9E6294B0';
    public static SixOne: string = '8C1FB2DC-CA18-4C21-9007-66B1789AEE1F';
    public static SevenOne: string = '4712CD54-A710-4F8B-A947-CBA9DDC74174';
    public static EightOne: string = '15FDD2B3-EB31-4FA1-8552-CFAC6DE284B8';
    public static NineOne: string = 'C11CAEDD-19ED-4EEB-A211-A9561949FD43';
    public static TenOne: string = 'E4EE5B47-DC25-4C76-8EC4-258263D328BE';
    public static ElevenOne: string = '4ABB7720-36C1-4CDF-A40D-D7415BDCCE55';
    public static TwelveOne: string = '7FC6A8BA-71FC-4262-84FF-C7DCF9CF3D1B';
    public static ThirteenOne: string = '918A1B35-6AE4-4CFB-A2C9-EDE2C7DCB0A1';
    public static FourteenOne: string = 'D932E87A-1D8B-4685-B739-22C67C241806';
    public static FivetennOne: string = '84561EEE-368F-4B8D-B169-C26B8C79506A';
    public static SixteenOne: string = '7634310B-0E24-454B-9789-1D140BC4BA3B';
    public static SeventeenOne: string = 'F608AAF3-0D9F-47E5-B9F1-A98C1DFBE5CB';
    public static EighteenOne: string = '421A3837-7161-4698-9820-436509031511';
    public static NineteenOne: string = 'BC05A937-C206-4991-B908-645335D14F84';
    public static TwentyOOne: string = 'C2D40476-43CA-4357-8CEC-6F4C9DA77831';
    public static TwentyoneOne: string = '38DBAA68-46DA-49AD-8EB2-406C978D9F0F';
    public static TwentytwoOne: string = '630014AB-0653-4D58-BFE6-09081046548D';
    public static TwentythreeOne: string = '1BDB14B4-4143-4381-A16D-3844243E2B75';
    public static TwentyfourOne: string = 'FCD03D86-A9AA-4EF4-A0D0-9C64F6F60F0B';
    public static TwentyfiveOne: string = 'CB4FD877-7A78-441B-A0FF-0E5FCA1BC771';
    public static TwentysixOne: string = '6BFD9B73-15A8-48B4-9ACC-EF8B9F4E2355';
    public static TwentysevenOne: string = 'B0ECA6B8-A1CA-49F7-BD0C-FC349C3B0DEE';
    public static TwentyeightOne: string = 'EFBF5002-3668-40B6-BA48-5358A78B9DFC';
    public static TwentynineOne: string = 'B3FC19D4-9C4D-485B-99C5-837863411400';
    public static ThirtyOOne: string = 'C19A90F0-AF99-4E00-A2A7-2B427AD810F6';
    public static ThirtyoneOne: string = 'CE73D44E-6C5D-4419-B29C-C50934FF3427';
    public static ThirtytwoOne: string = '6E20B855-6252-43EB-8C7E-5E2261D66FBE';
    public static ThirtythreeOne: string = '30513911-2431-4448-831C-F9A58B1C86AF';
    public static ThirtyfourOne: string = 'D8D03CD2-B438-4EE5-A2A9-A04C51546EEF';
    public static ThirtyfiveOne: string = '840D5899-A9F5-4571-91A5-8840C626A47C';
    public static ThirtysixOne: string = '4544CA2B-7D91-4043-8F3B-3E3A38B8EB6A';
    public static ThirtysevenOne: string = 'D59AD9DD-4322-4F2E-BE0F-FE4D24069C74';
    public static ThirtyeightOne: string = 'EF02DB19-0777-4FDB-9C02-4ECD8309FE5A';
    public static ThirtynineOne: string = '248FCF27-17DC-4FCD-B740-72534B81FD82';
    public static FourtyOOne: string = 'C1563026-8688-4CE7-B37F-D4BA43226A55';
    public static FourtyoneOne: string = '1348A0F2-CFB1-47AC-A465-73E779949A8C';
    public static FourtytwoOne: string = '198F4F79-E85B-42FE-9BD3-A077CE5BDE83';
}

export class BoxType {
    public static Storage: string = '16AA28B5-B0FC-EA11-A2D2-005056822A85';
    public static Shipment: string = '17AA28B5-B0FC-EA11-A2D2-005056822A85';
}

//SHIPMENT MANIFEST
export class shipmentSelectionType {
    public static Study: string = '2D62DF3E-FEA6-EA11-A2C4-005056822A85';
    public static Sites: string = 'AEA47D95-FEA6-EA11-A2C4-005056822A85';
    public static Visits: string = 'AFA47D95-FEA6-EA11-A2C4-005056822A85';
    public static Tests: string = 'B0A47D95-FEA6-EA11-A2C4-005056822A85';
    public static Location: string = 'B1A47D95-FEA6-EA11-A2C4-005056822A85';
    public static Accessions: string = 'B2A47D95-FEA6-EA11-A2C4-005056822A85';
    public static CUID: string = '5097134e-1cd1-ec11-a304-005056822a85';
    public static IssueNumber: string = '715789bc-36d8-ec11-a304-005056822a85';
    public static Derivatives: string = '58CA04A7-8A13-4B53-B100-E31654453278';
}

export class shipmentStatus {
    public static Created: string = '4AE18876-03A7-EA11-A2C4-005056822A85';
    public static PartiallyReadyForShipment: string = '7405C1A1-6576-EB11-A2ED-005056827D1F';
    public static ReadyForShipment: string = '198BB774-BBCA-EA11-A2CD-005056822A85';
    public static Shipped: string = '4BE18876-03A7-EA11-A2C4-005056822A85';
    public static Cancelled: string = '4CE18876-03A7-EA11-A2C4-005056822A85';
    public static InProgress: string = '773E1E63-BF30-41DC-AD0E-4D7ED742957E';
}

//Destruction MANIFEST
export class destructionSelectionType {
    public static Study: string = '2D62DF3E-FEA6-EA11-A2C4-005056822A85';
    public static Sites: string = 'AEA47D95-FEA6-EA11-A2C4-005056822A85';
    public static Visits: string = 'AFA47D95-FEA6-EA11-A2C4-005056822A85';
    public static Tests: string = 'B0A47D95-FEA6-EA11-A2C4-005056822A85';
    public static Location: string = 'B1A47D95-FEA6-EA11-A2C4-005056822A85';
    public static Accessions: string = 'B2A47D95-FEA6-EA11-A2C4-005056822A85';
    public static CUID: string = '5097134e-1cd1-ec11-a304-005056822a85';
    public static IssueNumber: string = '715789bc-36d8-ec11-a304-005056822a85';
    public static Derivatives: string = '58CA04A7-8A13-4B53-B100-E31654453278';
}

export class destructionStatus {
    public static Created: string = '97EFF9BA-8960-EB11-A2EB-005056827D1F';
    public static PartiallyDestroyed: string = 'EC35C356-8A60-EB11-A2EB-005056827D1F';
    public static Destructed: string = '99EFF9BA-8960-EB11-A2EB-005056827D1F';
    public static Cancelled: string = '9AEFF9BA-8960-EB11-A2EB-005056827D1F';
}

export class pickListStatus {
    public static Draft: string = '088D6DD9-1559-ED11-A336-005056827D1F';
    public static Active: string = '098D6DD9-1559-ED11-A336-005056827D1F';
    public static Completed: string = '0A8D6DD9-1559-ED11-A336-005056827D1F';
    public static Cancelled: string = '0B8D6DD9-1559-ED11-A336-005056827D1F';
}

export class SampleDashboardView {
    public static AllSamples: string = '5BDC7B88-5DBF-4698-AD02-FEF2C56C84BC';
    public static ExpectedVsReceived: string = '5DDC7B88-5DBF-4698-AD02-FEF2C56C84BC';
    public static ParcelSampleCount: string = '5CDC7B88-5DBF-4698-AD02-FEF2C56C84BC';
    public static samplepriority: string = '46BABD45-4E71-EC11-A30B-005056827D1F';
}

export class ExportRequestStatus {
    public static InProgress: string = '12D8DCED-E323-EB11-A2E1-005056827D1F';
    public static Completed: string = '13D8DCED-E323-EB11-A2E1-005056827D1F';
    public static Failed: string = '14D8DCED-E323-EB11-A2E1-005056827D1F';
}

export class SampleStatus {
    public static Active: string = '51DC7B88-5DBF-4698-AD02-FEF2C56C84BC';
    public static Received: string = '52DC7B88-5DBF-4698-AD02-FEF2C56C84BC';
    public static NotReceived: string = '53DC7B88-5DBF-4698-AD02-FEF2C56C84BC';
    public static Destroyed: string = '54DC7B88-5DBF-4698-AD02-FEF2C56C84BC';
    public static Shipped: string = '55DC7B88-5DBF-4698-AD02-FEF2C56C84BC';
    public static Consumed: string = '59DC7B88-5DBF-4698-AD02-FEF2C56C84BC';
    public static Discrepant: string = '5ADC7B88-5DBF-4698-AD02-FEF2C56C84BC';
}

export class hardCopyType {
    public static HardCopyYes: string = 'F52A10A2-7CD3-E611-9F36-005056B00B08';
    public static HardCopyNo: string = 'F62A10A2-7CD3-E611-9F36-005056B00B08';
}

export class ShipTemplateFields {
    public static BoxName: string = '0129EA72-FBD6-E611-9F36-005056B00B08';
}

export class IssueOrigin {
    public static Parcel: string = 'E08DA15D-31CF-EB11-A2F6-005056827D1F';
    public static SampleRegistration: string = 'E8B1C572-31CF-EB11-A2F6-005056827D1F';
    public static SampleMaintenance: string = '0A6CBB83-31CF-EB11-A2F6-005056827D1F';
    public static Custom: string = 'AC647314-32CF-EB11-A2F6-005056827D1F';
    public static SampleReception: string = '39E0B79E-ACDB-EE11-A350-005056822A85';
}

export class MainIssueStatuses {
    public static Opened: string = 'AE307BAB-51B6-EB11-A2ED-005056822A85';
    public static Closed: string = 'AF307BAB-51B6-EB11-A2ED-005056822A85';
    public static InProgress: string = '86D70819-3FCF-EB11-A2F6-005056827D1F';
    public static PCActionItem: string = '87D70819-3FCF-EB11-A2F6-005056827D1F';
    public static ClientContacted: string = '88D70819-3FCF-EB11-A2F6-005056827D1F';
    public static ClientProvidedResolution: string = '89D70819-3FCF-EB11-A2F6-005056827D1F';
    public static LabActionItem: string = '8AD70819-3FCF-EB11-A2F6-005056827D1F';
    public static OnHold: string = '8BD70819-3FCF-EB11-A2F6-005056827D1F';
    public static Reopened: string = '8CD70819-3FCF-EB11-A2F6-005056827D1F';
    public static Draft: string = '8DD70819-3FCF-EB11-A2F6-005056827D1F';
    public static CreatedByError: string = '8ED70819-3FCF-EB11-A2F6-005056827D1F';
    public static ClosedNoSampleReceived: string = 'A8341578-D808-ED11-A333-005056822A85';
    public static ClosedSampleReceived: string = 'A9341578-D808-ED11-A333-005056822A85';
    public static Cancelled: string = 'B2E7FCD6-1CFE-ED11-A343-005056827D1F';
}

export class SubIssueStatuses {
    public static Opened: string = '41CD5BDB-3FCF-EB11-A2F6-005056827D1F';
    public static Closed: string = '42CD5BDB-3FCF-EB11-A2F6-005056827D1F';
    public static InProgress: string = '39CD5BDB-3FCF-EB11-A2F6-005056827D1F';
    public static PCActionItem: string = '3ACD5BDB-3FCF-EB11-A2F6-005056827D1F';
    public static ClientContacted: string = '3BCD5BDB-3FCF-EB11-A2F6-005056827D1F';
    public static ClientProvidedResolution: string = '3CCD5BDB-3FCF-EB11-A2F6-005056827D1F';
    public static LabActionItem: string = '3DCD5BDB-3FCF-EB11-A2F6-005056827D1F';
    public static OnHold: string = '3ECD5BDB-3FCF-EB11-A2F6-005056827D1F';
    public static Reopened: string = '3FCD5BDB-3FCF-EB11-A2F6-005056827D1F';
    public static Draft: string = '40CD5BDB-3FCF-EB11-A2F6-005056827D1F';
    public static ClosedNoSampleReceived: string = '97530618-790D-ED11-A330-005056827D1F';
    public static ClosedSampleReceived: string = '98530618-790D-ED11-A330-005056827D1F';
    public static Cancelled: string = '55C70F19-18FE-ED11-A343-005056827D1F';
}

export class IssueTypeList {
    public static LowVolume: string = 'FBE5B2F0-50B6-EB11-A2ED-005056822A85';
    public static SampleEmpty: string = 'FCE5B2F0-50B6-EB11-A2ED-005056822A85';
    public static IncorrectSampleType: string = 'FDE5B2F0-50B6-EB11-A2ED-005056822A85';
    public static IncorrectTemperature: string = 'FEE5B2F0-50B6-EB11-A2ED-005056822A85';
    public static SampleLeaked: string = 'FFE5B2F0-50B6-EB11-A2ED-005056822A85';
    public static SampleMislabeled: string = '00E6B2F0-50B6-EB11-A2ED-005056822A85';
    public static MissingLabel: string = '01E6B2F0-50B6-EB11-A2ED-005056822A85';
    public static IncompleteDocumentation: string = '02E6B2F0-50B6-EB11-A2ED-005056822A85';
    public static DiscrepantDocumentation: string = '03E6B2F0-50B6-EB11-A2ED-005056822A85';
    public static MissingDocumentation: string = '04E6B2F0-50B6-EB11-A2ED-005056822A85';
    public static Misroute: string = '05E6B2F0-50B6-EB11-A2ED-005056822A85';
    public static MultipleIssues: string = '09E6B2F0-50B6-EB11-A2ED-005056822A85';
    public static Other: string = '0AE6B2F0-50B6-EB11-A2ED-005056822A85';
}

export class DiscrepancyList {
    public static Damaged: string = '7443073A-4E5C-E911-BB4A-005056B00B08';
    public static WrongDestination: string = '936A916C-4E5C-E911-BB4A-005056B00B08';
    public static IncorrectTemperature: string = '946A916C-4E5C-E911-BB4A-005056B00B08';
    public static IncompleteDocumentation: string = '956A916C-4E5C-E911-BB4A-005056B00B08';
    public static DiscrepantDocumentation: string = '966A916C-4E5C-E911-BB4A-005056B00B08';
    public static MissingDocumentation: string = '976A916C-4E5C-E911-BB4A-005056B00B08';
    public static Misroute: string = '986A916C-4E5C-E911-BB4A-005056B00B08';
    public static MultipleIssues: string = '996A916C-4E5C-E911-BB4A-005056B00B08';
    public static Other: string = '9A6A916C-4E5C-E911-BB4A-005056B00B08';
}

export class StudySiteContactStatus {
    public static Draft: string = '32b08fed-e1ea-eb11-a2f3-005056822a85';
    public static PendingForApproval: string = '33b08fed-e1ea-eb11-a2f3-005056822a85';
    public static Approved: string = '0fff96f5-e1ea-eb11-a2f3-005056822a85';
    public static Rejected: string = '10ff96f5-e1ea-eb11-a2f3-005056822a85';
}

export class AuditModuleNames {
    public static Accession: string = 'accession';
    public static User: string = 'users';
    public static Template: string = 'template';
    public static Modules: string = 'modules';
    public static Study: string = 'study';
    public static Cuid: string = 'cuid';
}

export class AuditTemplateStatus {
    public static Enable: string = '184A2308-83DE-ED11-A33F-005056827D1F';
    public static Disable: string = '194A2308-83DE-ED11-A33F-005056827D1F';
}

export class SampleRegistrationStatusText {
    public static PartiallyCancelled: string = 'Partially Cancelled';
    public static Cancelled: string = 'Cancelled';
}

export class BillingTypes {
    public static SampleStorageResulted: string = 'A4122E92-5242-EE11-A34A-005056822A85';
    public static SampleStorageReceived: string = 'A5122E92-5242-EE11-A34A-005056822A85';
    public static Shipped: string = 'A6122E92-5242-EE11-A34A-005056822A85';
    public static Destroyed: string = 'A7122E92-5242-EE11-A34A-005056822A85';
    public static DataManagement: string = 'A8122E92-5242-EE11-A34A-005056822A85';
    public static Milestone: string = 'A9122E92-5242-EE11-A34A-005056822A85';
    public static AssayMaintenance: string = 'AA122E92-5242-EE11-A34A-005056822A85';
    public static Materials: string = 'AB122E92-5242-EE11-A34A-005056822A85';
    public static SampleHandling: string = 'AE122E92-5242-EE11-A34A-005056822A85';
    public static ProjectManagement: string = 'AF122E92-5242-EE11-A34A-005056822A85';
    public static Amendments: string = 'B0122E92-5242-EE11-A34A-005056822A85';
    public static IT: string = 'B1122E92-5242-EE11-A34A-005056822A85';
    public static Quality: string = '1968F758-EC56-EE11-A34B-005056822A85';
    public static MISC: string = '1A68F758-EC56-EE11-A34B-005056822A85';
    public static PassThrough: string = '1B68F758-EC56-EE11-A34B-005056822A85';
    public static Reports: string = '1C68F758-EC56-EE11-A34B-005056822A85';
    public static BenchDays: string = '33789E84-D266-EE11-A34C-005056822A85';
}

export class BillingUnits {
    public static Individual: string = 'C8B0CC5B-0A40-EE11-A34A-005056822A85';
    public static Bulk: string = '059EF57C-0A40-EE11-A34A-005056822A85';
}

export class BillingFrequency {
    public static Once: string = '96690CB8-0A40-EE11-A34A-005056822A85';
    public static Monthly: string = 'D03F2C0F-0B40-EE11-A34A-005056822A85';
    public static Quarterly: string = '52686940-0B40-EE11-A34A-005056822A85';
}

export class EncryptionKeys {
    public static CaptchaSiteKey: string = '6Lc2mk4cAAAAAKIL11jVbJEnxtVwGrLPcNBHakPe';
    public static PasswordEncryptionKey: string = 'a1b2c3d4e5f6g7h8';
    public static PasswordEncryptionIV: string = '8h7g6f5e4d3c2b1a';
}

export var deafaultRoleList: string[] = [
    '695E26CB-75D6-E611-9F36-005056B00B08'.toLowerCase(),
    '16BA90EF-E3EA-EB11-A2F3-005056822A85'.toLowerCase(),
    '3CD7075B-70D6-E611-9F36-005056B00B08'.toLowerCase(),
    '13BA90EF-E3EA-EB11-A2F3-005056822A85'.toLowerCase(),
    '15BA90EF-E3EA-EB11-A2F3-005056822A85'.toLowerCase(),
    '14BA90EF-E3EA-EB11-A2F3-005056822A85'.toLowerCase(),
    '12BA90EF-E3EA-EB11-A2F3-005056822A85'.toLowerCase(),
    'F7F0C30E-40E8-E611-9F36-005056B00B08'.toLowerCase()
]